function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhantom = function SvgPhantom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phantom_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    y1: 0,
    x2: 64,
    y2: 128,
    gradientTransform: "scale(.21875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#534bb1",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#551bf9",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "phantom_svg__b",
    gradientUnits: "userSpaceOnUse",
    x1: 65.5,
    y1: 23,
    x2: 65.5,
    y2: 108,
    gradientTransform: "scale(.21875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff",
      stopOpacity: 0.819608
    }
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#phantom_svg__a)"
    },
    d: "M28 14c0 7.73-6.27 14-14 14S0 21.73 0 14 6.27 0 14 0s14 6.27 14 14Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#phantom_svg__b)"
    },
    d: "M24.191 14.2h-2.503c0-5.063-4.149-9.169-9.27-9.169-5.055 0-9.164 4.004-9.266 8.98-.105 5.145 4.774 9.614 9.977 9.614h.656c4.582 0 10.73-3.55 11.692-7.879.175-.797-.461-1.547-1.286-1.547ZM8.7 14.425c0 .676-.558 1.23-1.246 1.23a1.24 1.24 0 0 1-1.242-1.23v-1.992c0-.676.559-1.23 1.242-1.23.688 0 1.246.554 1.246 1.23Zm4.32 0a1.24 1.24 0 0 1-1.242 1.23 1.241 1.241 0 0 1-1.246-1.23v-1.992c0-.676.563-1.23 1.246-1.23a1.24 1.24 0 0 1 1.243 1.23Zm0 0"
  }));
};
export default SvgPhantom;